﻿import creator from '../elementCreator';
import global from '../globals';
import layerhelp from './helptextgenerator';

"use strict";

var privateFns;
privateFns = {
	forEachRecursive: function (lyr, fn) {
		lyr.getLayers().forEach(
			/**
			* @param {{getLayers:method}} lyr
			* @param idx
			* @param a
			*/
			function (lyr, idx, a) {
				fn(lyr, idx, a);
				if (lyr.getLayers) {
					privateFns.forEachRecursive(lyr, fn);
				}
			}
		);
	},
	addQuickSearch: function(target){
		var modeSelect = creator.createSelect({id: "quickSearch"});
		var label = creator.createLabel({htmlfor: "quickSearch", text: "Hurtigvalg: "});
		Object.keys(global.modes).filter(mode => global.modes[mode].layers && global.modes[mode].displayName).forEach(function(mode){
			mode = global.modes[mode];
			let textValue = mode.displayName ? mode.displayName : mode.mode;
			var opt = creator.createOption({text: textValue, value: mode.mode});
			modeSelect.appendChild(opt);
		});
		modeSelect.onchange = function(e){
			var mode = this.value;
			privateFns.turnOffAllLayers();
			if (global.modes[mode].layers) {
				if(Array.isArray(global.modes[mode].layers)){
					global.modes[mode].layers.forEach(function(layer){
						if($("#"+layer).length){
							$("#"+layer).click();
						}
					});
				}else{
					global.modes[mode][0]();
				}
			}
			global.mapMode = mode;
			history.replaceState({}, "planinnsyn", window.location.href.split("?")[0].split("#")[0] + "?mode=" + this.value);
		}
		target.appendChild(label);
		target.appendChild(modeSelect);
	},
	turnOffAllLayers: function(){
		privateFns.forEachRecursive(global.map, function(l){
			var layer = l.values_.layerId;
			if($("#"+layer)[0] && $("#"+layer)[0].checked && !$("#"+layer)[0].parentElement.parentElement.firstChild.classList.contains("mapmenu-expander")){
				$("#"+layer).click();
			}
		});
	},
	addMapmenu: function () {
		let nav = creator.createNav({css: "mapmenu", id: "mapmenu"});
		let wrapper = creator.createDiv({css: "mapmenu-wrapper"});
		let container = creator.createDiv({id: "mapmenu-ct"});
		wrapper.appendChild(container);				
		if(global.appConfig.quickSearch){
			privateFns.addQuickSearch(container);				
		}
		nav.appendChild(wrapper);
		$("#header").after(nav);
	},
	addNavToggler: function (header) {
		var div = creator.createDiv({ id: "navToggler", css: "navtoggler navtogglerStyler navtogglerActive"});
		div.appendChild(creator.createButton({
			css: "buttonToggler",
			id: "layerMenuToggler",
			text: "<span id = 'spanToggler' class = 'spanTogglerRemove'>" + header + "</span><i class='icon-Close' style=\"padding-top: 10px;\"></i>",
			onclick: function (e) {
				$("#navToggler").toggleClass("navtoggler-toggled").toggleClass("navtogglerActive");
				$("#navToggler").find("i").toggleClass("icon-Menu").toggleClass("icon-Close");
				$("#spanToggler").toggleClass("spanTogglerActive").toggleClass("spanTogglerRemove");
				$(".mapmenu").toggleClass("nav-toggled");
			}
		}));
		$("#header").after(div);
	},
	createLayerMenuContainer: function (header) {
		privateFns.addMapmenu();
		privateFns.addNavToggler(header);
	},
	loopLayers: function (layers, target) {
		layers.forEach(function (l) {
			if (l.layers) {
				var groupContainer = privateFns.createGroupContainer(l);
				if (l.groupCheckbox) {
					target.appendChild(privateFns.createLayerElement(l));
					if(l.legend){
						target.appendChild(privateFns.createLegendLi(l));
					}
				} else if (l.title) {
					target.appendChild(privateFns.createGroupTitle(l));
				}
				target.appendChild(groupContainer);
				privateFns.loopLayers(l.layers, groupContainer);
			} else {
				/* Enkeltkartlag */
				if(l.displayInLayerMenu){						
					target.appendChild(privateFns.createLayerElement(l));
					if(l.legend){
						target.appendChild(privateFns.createLegendLi(l));
					}
				}else if(l.hiddenToggle){
					let hiddenToggleBox = privateFns.createLayerElement(l);
					$(hiddenToggleBox).hide();
					target.appendChild(hiddenToggleBox);
				}
				if (l.calendar) {
					privateFns.createCalendarInput(
						l.layerId,
						l.maxDateTo,
						l.minDateFrom,
						l.url
					);
				}
			}
		});
	},
	createGroupTitle: function (l) {
		var title = creator.createH3({text: l.title, id: l.layerId});
		if (l.groupCheckbox === false && l.collapsible) {
			title.appendChild(privateFns.createGroupExpander());
		}
		return title;
	},
	createGroupContainer: function (l) {
		var ul = creator.createUl({id: l.layerId + "-ct", css: l.collapsible ? "collapsed-layer-ct" : "sub-layer-group"});
		return ul;
	},
	createLegendLi: function(l){
		var li = creator.createLi({});
		var wrapper = creator.createDiv({id: "layer" + l.layerId + "-legend"});
		var img = creator.createImage({src: l.legend});
		wrapper.appendChild(img);
		li.appendChild(wrapper);
		return li;
	},
	createLayerElement: function (l) {
		var li = creator.createLi({});
		var wrapper = creator.createDiv({id: "layer" + l.layerId + "-ct"});
		
		var input = creator.createInput({});
		if (l.radio) {
			input.type = "radio";
			input.name = l.parentId;
		} else {
			input.type = "checkbox";
		}
		input.id = l.layerId;
		input.checked = l.visible;
		$(input).click(function (e) {
			if (e.currentTarget.indeterminate) {
				$(e.currentTarget).data("inditerm", true);
			} else {
				if ($(e.currentTarget).data("inditerm")) {
					this.checked = false;
					var evt = document.createEvent("HTMLEvents");
					evt.initEvent("change", false, true);
					this.dispatchEvent(evt);
				}
				$(e.currentTarget).data("inditerm", false);
			}
		}).change(privateFns.onChangeSetVisible);

		var label = creator.createLabel({htmlfor: l.layerId, text: l.title});
		if (l.layerInfo) {
			label.appendChild(privateFns.createLayerInfoButton(l));
		}
		label.appendChild(privateFns.appendLoader());

		wrapper.appendChild(input);
		wrapper.appendChild(label);

		if (l.layers) {
			var title;
			if (l.title.indexOf("<") !== -1) {
				title = l.title.substring(0, 9);
			} else {
				title = l.title;
			}
			li.appendChild(privateFns.createGroupExpander(title));
		}
		li.appendChild(wrapper);

		return li;
	},
	appendLoader: function () {
		return creator.createIcon({css: "layerloader fa fa-spinner fa-pulse"});
	},
	createLayerInfoButton: function (l) {
		var customLayerInfo = l.customLayerInfo;
		var button = creator.createButton({
			text: "Mer info", 
			css: "mapmenu-info", 
			onclick: function (e) {
				$(".navtoggler").toggleClass("navtoggler-toggled");
				$(".mapmenu").toggleClass("nav-toggled");

				$(".layerinfo").toggleClass("layerinfo-show");
				if (customLayerInfo) {
					$("#layerinfo-ct").html(customLayerInfo);
				} else {
					$("#layerinfo-ct").html(layerhelp.getInfoTextFor(e.currentTarget.parentElement.previousSibling.id));
				}
				e.preventDefault();
			}
		});
		return button;
	},
	createGroupExpander: function (title) {
		var button = creator.createButton({css: "mapmenu-expander", ariaLabel: "Vis " + title});
		button.appendChild(creator.createIcon({css: "icon-Chevron-down"}));

		button.onclick = function (e) {
			if(e.currentTarget){				
				if (e.currentTarget.parentElement.nodeName === "LI") {
					var label = e.currentTarget.parentElement.lastChild.lastChild.firstChild.textContent;
					privateFns.toggleAriaLabel(button, label);
					// Går gjennom alle ekspander-knappene i kartlagsmenyen
					$(".mapmenu").find(".mapmenu-expander").each(function (index, el) {
						var currentUl = e.currentTarget.parentElement.nextSibling;
						var thisUl = el.parentElement.nextSibling;
						if (el === e.currentTarget && index >= 0) {
							// hvis knappen er den det ble trykket på (index >= 0 er bare for å unngå feilmelding på ubrukt variabel..)
							$(el).find("i").toggleClass("icon-Chevron-down").toggleClass("icon-Chevron-upFill");
							$(currentUl).toggle();
						} else if ($(thisUl).find("#" + currentUl.id).length === 0) {
							// hvis knappen ikke er den det ble trykket på og ikke er foreldre til knappen det ble trykket på
							//$(el).find("i").toggleClass("oslo-chevron-down").toggleClass("oslo-chevron-up");
							//$(thisUl).hide();
						}
					});
				} else {
					var label2 = e.currentTarget.parentElement.textContent;
					privateFns.toggleAriaLabel(button, label2);
					$(e.currentTarget).find("i").toggleClass("icon-Chevron-down").toggleClass("icon-Chevron-upFill");
					$(e.currentTarget.parentElement.nextSibling).toggle();
				}
			}else if(e.target){
				var label2 = e.target.parentElement.textContent;
					privateFns.toggleAriaLabel(button, label2);
					$(e.target).find("i").toggleClass("icon-Chevron-down").toggleClass("icon-Chevron-upFill");
					$(e.target.parentElement.nextSibling).toggle();
			}
		};

		return button;
	},
	toggleAriaLabel: function (button, label) {
		if (button.getAttribute("aria-label").indexOf("Vis") > -1) {
			button.setAttribute("aria-label", "Skjul " + label);
		} else {
			button.setAttribute("aria-label", "Vis " + label);
		}
	},
	createLayerinfoPage: function () {
		var page = creator.createAside({css: "layerinfo"});
		var topDiv = creator.createDiv({css: "top-div"});
		topDiv.appendChild(creator.createButton({
			className: "close-me",
			ariaLabel: "Skjul kartlagsinformasjon",
			icon: true,
			iconClass: "icon-Close",
			onclick: function () {
				$(page).removeClass("layerinfo-show");
				$(".navtoggler").toggleClass("navtoggler-toggled");
				$(".mapmenu").toggleClass("nav-toggled");
				$("#layerinfo-ct").html("");
			}
		}));
		page.appendChild(topDiv);
		page.appendChild(creator.createSection({
			css: "layerinfoContainer",
			id: "layerinfo-ct"
		}));
		$(".mapmenu").after(page);
	},
	specialSetVisible(layer, visible){
		if(!layer.get("conditional")){
			layer.setVisible(visible);
		}
		if(layer.get("dependent")) {
			privateFns.specialSetVisible(global.map.getLayerById(layer.get("dependent")), visible);
		}
		if(layer.get("exclude")){
			privateFns.specialSetVisible(global.map.getLayerById(layer.get("exclude")), !visible);
		}
		if(layer.get("conditional")){
			if(visible){					
				if(global.map.getLayerById(layer.get("conditional").condition).getVisible()){
					privateFns.specialSetVisible(global.map.getLayerById(layer.get("conditional").trigger), visible);
				}else{
					layer.setVisible(visible);
				}
			}else{
				privateFns.specialSetVisible(global.map.getLayerById(layer.get("conditional").trigger), visible);
				layer.setVisible(visible);
			}
		}
	},
	onChangeSetVisible: function (e) {
		var target = e.currentTarget || e.target;

		var layerId = target.id;

		/* Setter sjekkbokser i kontekstmenyen hvis kartet finnes der */
		privateFns.toggleContextMenuLayerCheckbox(layerId, target.checked);

		var layer = global.map.getLayerById(layerId);
		privateFns.specialSetVisible(layer, target.checked);
		if(document.getElementById("layer" + layerId + "-legend")){
			if(target.checked){
				document.getElementById("layer" + layerId + "-legend").style.display = "block";
			}else{
				document.getElementById("layer" + layerId + "-legend").style.display = "none";
			}
		}
		
		if (target.type === "radio") {
			privateFns.forEachRecursive(global.map, function (l) {
				if (l !== layer && l.get("parentId") === layer.get("parentId") && l.get("radio")) {
					l.setVisible(false);
					if (l.get("groupCheckbox")) {
						privateFns.cascadeSubLayers(l, false);
						privateFns.collapseGroup(l);
					}
				}
			});
		}

		/* Slår av eller på underkartlag hvis layer er et gruppekartlag */
		if (layer.get("groupCheckbox")) {
			privateFns.cascadeSubLayers(layer, target.checked);
			if (target.checked) {
				privateFns.expandGroup(layer);
			} else {
				privateFns.collapseGroup(layer);
			}
		}

		/* Slår av eller på gruppekartlag hvis layeret er et underkartlag */
		if (layer.get("parentId")) {
			privateFns.toggleParentLayer(layer);
		}

		/* Viser kalender for kalenderkartlag */
		if (layer.get("calendar")) {
			var calendar = $("#" + layerId + "-kalender");
			if (target.checked) {
				calendar.show();
			privateFns.setSelectedCalendarDates(layerId);
			} else {
				calendar.hide();
			}
		}

		/* Viser dataeier nederst i kartvinduet hvis eksternt kartlag */
		if (layer.get("attribution")) {
			privateFns.toggleAttribution(layer, layer.getVisible());
		}
	},
	toggleContextMenuLayerCheckbox: function (id, checked) {
		//if (id.indexOf("kp_tema_ikke_juridisk_luftforurensing") >= 0) {
		//	id = "kp_tema_ikke_juridisk_luftforurensing";
		//}
		$("#eie-content-show-" + id).prop("checked", checked);
		$("#punkt-content-show-" + id).prop("checked", checked);
	},
	cascadeSubLayers: function (group, visible) {
		group.getLayers().forEach(function (layer) {
			if (visible && !layer.get("dontCascade") ){
				layer.setVisible(visible);
				if(layer.values_.exclude){
					global.map.getLayerById(layer.values_.exclude).setVisible(!visible);
				}
				if(layer.values_.dependent){
					global.map.getLayerById(layer.values_.dependent).setVisible(visible);
				}
				$("#" + layer.get("layerId")).prop("checked", visible);
				/* Setter sjekkbokser i kontekstmenyen hvis kartet finnes der */
				privateFns.toggleContextMenuLayerCheckbox(layer.get("layerId"), visible);

				if (layer.getLayers) {
					privateFns.cascadeSubLayers(layer, visible);
				}
			} else if(!layer.get("dontCascade")) {
				group.getLayers().forEach(function (layer) {
					layer.setVisible(visible);
					if(layer.values_.dependent){
						global.map.getLayerById(layer.values_.dependent).setVisible(visible);
					}
					if(layer.values_.exclude){
						global.map.getLayerById(layer.values_.exclude).setVisible(!visible);
					}
					$("#" + layer.get("layerId")).prop("checked", visible);
					/* Setter sjekkbokser i kontekstmenyen hvis kartet finnes der */
					privateFns.toggleContextMenuLayerCheckbox(layer.get("layerId"), visible);

					if (layer.getLayers) {
						privateFns.cascadeSubLayers(layer, visible);
					}
				});
			};
			if (layer.get("attribution")) {
				privateFns.toggleAttribution(layer, visible);
			}
		});
	},
	expandGroup: function (layer) {
		$("#" + layer.get("layerId")).closest("li").find(".mapmenu-expander").find("i").removeClass("icon-Chevron-down").addClass("icon-Chevron-upFill");
		$("#" + layer.get("layerId") + "-ct").show();
	},
	collapseGroup: function (layer) {
		$("#" + layer.get("layerId")).closest("li").find(".mapmenu-expander").find("i").addClass("icon-Chevron-down").removeClass("icon-Chevron-upFill");
		$("#" + layer.get("layerId") + "-ct").hide();
	},
	toggleParentLayer: function (layer) {
		var parentLayer = global.map.getLayerById(layer.get("parentId"));
		var visibleSubLayer = privateFns.getVisibleLayer(parentLayer);
		parentLayer.setVisible(visibleSubLayer);
		var indeterminate = privateFns.getIndeterminateCheckboxState(parentLayer);
		//$("#" + layer.get("parentId")).prop("checked", visibleSubLayer).prop("indeterminate", true);
		var checkbox = $("#" + layer.get("parentId"));
		checkbox.prop("checked", visibleSubLayer);
		checkbox.prop("indeterminate", indeterminate);

		if (parentLayer.get("parentId")) {
			privateFns.toggleParentLayer(parentLayer);
		}
	},
	getVisibleLayer: function (parent) {
		var visible = false;
		if (parent.getLayers) {
			parent.getLayers().forEach(function (l) {
				if (l.getVisible()) {
					visible = true;
				}
			});
		} else {
			visible = parent.getVisible();
		}
		return visible;
	},
	getIndeterminateCheckboxState: function (parent) {
		var indeterminate = false, checked = "no", unchecked = "no";
		if (parent.getLayers) {
			parent.getLayers().forEach(function (l) {
				if (l.getVisible()) {
					checked = "yes";
				} else {
					unchecked = "yes";
				}
			});
		}
		if (checked === "yes" && unchecked === "yes") {
			indeterminate = true;
		}
		return indeterminate;
	},        
	toggleDefaultLayers: function () {
		global.defaults.forEach(function(layer){	
			privateFns.toggleRecursive(layer, true);
		});
	},    
	toggleRecursive: function(layer, first){
		if(document.getElementById(layer) && document.getElementById(layer).closest("li")){
			document.getElementById(layer).closest("li").parentNode.style.display = "block";
			if(document.getElementById(layer).closest("li").closest("ul").previousSibling.querySelectorAll("input[type=checkbox]")[0]){
				document.getElementById(layer).closest("li").closest("ul").previousSibling.querySelectorAll("input[type=checkbox]")[0].indeterminate = true;							
			}
			if(first && $("#"+layer).closest("li").closest("li").find(".mapmenu-expander")){
				document.getElementById(layer).closest("li").nextSibling.style.display = "block";
			}
			$("#"+layer).closest("li").closest("li").find(".mapmenu-expander").find("i").removeClass("icon-Chevron-down").addClass("icon-Chevron-upFill");
		}
		if(document.getElementById(layer) && document.getElementById(layer).closest("li") && document.getElementById(layer).closest("li").closest("ul").previousSibling.nodeName !== "H3"){
				privateFns.toggleRecursive(document.getElementById(layer).closest("li").closest("ul").previousSibling.querySelectorAll("input[type=checkbox]")[0].id);
		}else{
			$("#"+layer).find(".mapmenu-expander").find("i").removeClass("icon-Chevron-down").addClass("icon-Chevron-upFill");
			if(first && $("#"+layer).closest("li").closest("li").find(".mapmenu-expander") && document.getElementById(layer)){
				document.getElementById(layer).nextSibling.style.display = "block";
			}
		}
	},
	createCalendarInput: function (id, maxDateTo, maxDateFrom, postlisteUrl) {
		var holder = creator.createDiv({id: id + "-kalender", css: "calendar-container"});

		var calendarHeader = creator.createH4({text: "Periode"});
		holder.appendChild(calendarHeader);

		var warningDiv = creator.createDiv({css: "calendar-error"});
		holder.appendChild(warningDiv);

		privateFns.addDateInput(id + "-from-date", "Fra", "from-date", holder);
		privateFns.addDateInput(id + "-to-date", "Til", "to-date", holder);

		var antallDiv = creator.createDiv({css: "calendar-count"});
		holder.appendChild(creator.createBr({}));
		holder.appendChild(antallDiv);

		var button = creator.createSpan({
			type: "button",
			css: "ct-span-btn",
			text: "Oppdater kart",
			onclick: function () {
				privateFns.updateCalendarLayer(id, postlisteUrl);
			}			
		});
		holder.appendChild(button);

		$("#" + id).parent().parent().append(holder);
		$.fn.datepicker.defaults.format = "dd.mm.yyyy";
		$("#" + id + "-to-date-container").datepicker({
			format: 'dd.mm.yyyy',
			showOtherMonths: true,
			selectOtherMonths: false,
			maxDate: maxDateTo,
		});
		$("#" + id + "-from-date-container").datepicker({
			format: 'dd.mm.yyyy',
			showOtherMonths: true,
			selectOtherMonths: false,
			maxDate: maxDateFrom
		});
	},
	addDateInput: function (id, html, name, target) {
		var container = creator.createDiv({css: "input-group date datepicker", id: id + "-container"});
		
		var label = creator.createLabel({htmlfor: id, text: html});
		target.appendChild(label);
		
		var input = creator.createInput({type: "text", id: id, name: name, css: "form-control"});
		container.appendChild(input);
		
		var span = creator.createSpan({css: "input-group-addon"});
		container.appendChild(span);
		
		var icon = creator.createIcon({css: "icon-Kalender"});
		span.appendChild(icon);
		
		container.appendChild(span);
		
		target.appendChild(container);
		
	},
	 setSelectedCalendarDates: function (id) {
		var fromDateInput = $("#" + id + "-from-date");
		var toDateInput = $("#" + id + "-to-date");
		if (fromDateInput.datepicker("getDate") === null) {
			var lowerDate = new Date();
			lowerDate.setDate(lowerDate.getDate() - 9);
			fromDateInput.datepicker("setDate", lowerDate);
		}
		if (toDateInput.datepicker("getDate") === null) {
			var upperDate = new Date();
			upperDate.setDate(upperDate.getDate() - 2);
			toDateInput.datepicker("setDate", upperDate);
		}
	},
	updateCalendarLayer: function (id, postlisteUrl) {
		var calendar = $("#" + id + "-kalender");
		calendar.find(".calendar-count").html("<p>Antall dokumenter: ...</p>");
		var fromInput = $("#" + id + "-from-date");
		var toInput = $("#" + id + "-to-date");
		var warningDiv = calendar.find(".calendar-error");
		warningDiv.empty();
		var fromDate = $.datepicker.formatDate("yymmdd", fromInput.datepicker("getDate"));
		var toDate = $.datepicker.formatDate("yymmdd", toInput.datepicker("getDate"));
		var goOn = true;
		if (fromDate === "" || toDate === "") {
			warningDiv.html("<p>Det må velges en dato i begge felt.</p>");
			goOn = false;
		} else if (fromDate > toDate) {
			warningDiv.html("<p>Fra dato må være tidligere enn til dato.</p>");
			fromInput.datepicker("setDate", null);
			toInput.datepicker("setDate", null);
			goOn = false;
		}

		if (goOn) {
			var layer = global.map.getLayerById(id);
			var newSource;
			newSource = new ol.source.Vector({
				loader: function () {
				var url = postlisteUrl + "&outputformat=geojson&srs=EPSG:4326&typename=postliste_dato&Filter=<Filter><PropertyIsBetween><PropertyName>D</PropertyName>";
				url += "<LowerBoundary>" + fromDate + "</LowerBoundary>";
				url += "<UpperBoundary>" + toDate + "</UpperBoundary></PropertyIsBetween>";
				url += "</Filter>";
				privateFns.toggleLayerLoader(id, "inline-block");
				$.ajax({
					url: url,
					dataType: "json",
					jsonp: true,
					success: function (r) {
						var f = new ol.format.GeoJSON();
						privateFns.toggleLayerLoader(id, "none");
						var features = f.readFeatures(r);
						newSource.addFeatures(features);
						calendar.find(".calendar-count").html("<p>Antall dokumenter: " + features.length + "</p>");
					},
					fail: function (r) {
						console.error(r);
						privateFns.toggleLayerLoader(id, "none");
						calendar.find(".calendar-count").html("<p>Antall dokumenter: 0</p>");
					},
					error: function () {
						privateFns.toggleLayerLoader(id, "none");
						calendar.find(".calendar-count").html("<p>Antall dokumenter: 0</p>");
					}
				});
				},
				strategy: ol.loadingstrategy.all
			});
			var newClusterSource = new ol.source.Cluster({
			distance: 30,
			source: newSource
			});
			layer.setSource(newClusterSource);
		}
	},
	 toggleLayerLoader: function (id, value) {
		$("#" + id).next().find(".layerloader").css("display", value);
	},
	toggleAttribution: function (layer, visible) {
		var id = layer.get("attributionId");
		var target = $("#" + id);

		var parentLayer = global.map.getLayerById(layer.get("parentId"));
		var visibleSubLayer = false;
		if (parentLayer.get("attributionId") === layer.get("attributionId")) {
			visibleSubLayer = privateFns.getVisibleLayer(parentLayer);
		} else {
			global.map.getLayersBy("attributionId", id).forEach(function (l) {
				if (l.getVisible()) {
					visibleSubLayer = true;
				}
			});
		}
		if (visible) {
			if (target.length === 0) {
				var element = creator.createSpan({id: id, css: "ui-link", text: layer.get("attribution")});
				$("#attribution-ct").append(element);
			}
		} else {
			if (visibleSubLayer === false) {
				target.remove();
			}
		}
	},
	toggleCssScreenSize: function(){
		var ww = document.body.clientWidth;
		if (ww < 992) {
			$('.navtoggler').removeClass('navtogglerActive').addClass('navtoggler-toggled');
			$('.navtoggler').find("i").addClass("icon-Menu").removeClass("icon-Close");
		}else{
			$('.navtoggler').removeClass('navtoggler-toggled').addClass('navtogglerActive');
			//$('.navtoggler').find("i").addClass("icon-Menu").removeClass("icon-Close");
		}
	},
};
    
export default {
	initiate: function(layers, header){
		privateFns.createLayerMenuContainer(header);
		privateFns.createLayerinfoPage();
		privateFns.loopLayers(layers, document.getElementById("mapmenu-ct"));
		privateFns.toggleDefaultLayers();
		privateFns.toggleCssScreenSize();		
		$(window).resize(function(){
			privateFns.toggleCssScreenSize();				
		});
	},
	loopLayers: privateFns.loopLayers,
};